import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { userValidator, useValidatorStore } from '@features/proxy';
import { pageRedirects, useLoginInfoStore } from '@features/shared';

export const ValidateUserStatus = () => {
  const [searchParams] = useSearchParams();
  const { userInfo } = useLoginInfoStore();
  const { setValidateStep } = useValidatorStore();

  const channel = searchParams.get('channel') || 'btp';

  // AD 유저이면서, 채널이 없는 경우
  const isAdUserWithoutChannel = useCallback(() => {
    const { isAdUser, hasChannel } = userValidator;

    if (isAdUser(userInfo) && !hasChannel(userInfo)) {
      if (channel === 'btp') return pageRedirects.approvalStatusError('btp');
      else return pageRedirects.newChannelAd({ uid: userInfo.UID ?? '', channel: channel });
    }
    return true;
  }, [channel, userInfo]);

  // 유저 상태 체크
  const validateUserStatus = useCallback(() => {
    const status = userInfo.data?.userStatus;
    const channels = userInfo.data?.channels || {};
    if (status === 'active' || status === 'inactive') {
      if (channel === 'btp') {
        const hasOneEmpPendingChannel = channels[Object.keys(channels)[0]].approvalStatus === 'emp-pending';
        // 채널이 btp 인데 승인 상태가 emp-pending 인 경우
        if (hasOneEmpPendingChannel) return pageRedirects.approvalStatusError('emp-pending');
        // btp는 무조건 consent-check 로 이동
        else return setValidateStep('consent-check');
      } else {
        return setValidateStep('approval-status-check');
      }
    } else if (status === 'regSubmit') {
      return pageRedirects.approvalStatusError('pending');
    } else if (status === 'regEmailVerified') {
      return pageRedirects.approvalStatusError('emailVerified');
    }
    return pageRedirects.approvalStatusError('disabled');
  }, [userInfo.data?.userStatus, userInfo.data?.channels, channel, setValidateStep]);

  useEffect(() => {
    const execute = async () => {
      const ok = isAdUserWithoutChannel();
      if (ok) validateUserStatus();
    };
    console.log('validate user status');
    execute();
  }, [isAdUserWithoutChannel, validateUserStatus]);

  return null;
};
